import {
  DataTableSource,
  type DataTablePageReq,
  type DataTablePageResp,
  type TableRow,
} from "@carbon6/c6-frontend-design";

/**
 * 이미 가진 행 목록을 c6 `DataTable` 계약(`DataTableSource`)으로 전달하는 정적 소스.
 *
 * 생성자가 로드 완료 상태를 동기로 시드한다. 그래서 initialize 왕복과 "Loading." 플래시가 없다.
 * 페이징하지 않는다. 대시보드 카드처럼 상위가 이미 잘라 온 소량 목록에 쓴다. 데이터가
 * 바뀌면 새 인스턴스를 만든다(상위가 `useMemo(rows)` 로 감싼다).
 */
export class StaticTableSource<Row extends TableRow> extends DataTableSource<Row> {
  private readonly staticRows: readonly Row[];

  constructor(rows: readonly Row[]) {
    super({ initialPageSize: Math.max(rows.length, 1) });
    this.staticRows = rows;
    this.replaceLoadedPage({
      rows,
      total: rows.length,
      page: 1,
      size: Math.max(rows.length, 1),
    });
  }

  protected override onPage(req: DataTablePageReq): Promise<DataTablePageResp<Row>> {
    return Promise.resolve({
      rows: this.staticRows,
      total: this.staticRows.length,
      page: req.page,
      size: req.size,
    });
  }
}
